// extracted by mini-css-extract-plugin
module.exports = {"Link":"LinkItem_Link__2ucfj"};